import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class ChatbotServiceService {

  constructor(private http: HttpClient) { }

  getChatbotInformation(data:any):Observable<any> {
    var url = environment.CHATBOAT_API_URL + 'fci_chatbot/';
    return this.http.post<any>(url, data); 
  }

  getDBData():Observable<any> {
    var url = environment.CHATBOAT_API_URL + 'get_data/';
    return this.http.get<any>(url);
  }

}
